/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AmpComponent } from './AmpComponent'
import { Ampp } from './Ampp'
import { Company } from './Company'
import { SamText } from './SamText'
import { VmpStub } from './VmpStub'

export class Amp {
  constructor(json: JSON | any) {
    Object.assign(this as Amp, json)
  }

  id?: string
  rev?: string
  /**
   * hard delete (unix epoch in ms) timestamp of the object. Filled automatically when deletePatient is called.
   */
  deletionDate?: number
  from?: number
  to?: number
  code?: string
  vmp?: VmpStub
  officialName?: string
  status?: Amp.StatusEnum
  name?: SamText
  blackTriangle?: boolean
  medicineType?: Amp.MedicineTypeEnum
  company?: Company
  abbreviatedName?: SamText
  proprietarySuffix?: SamText
  prescriptionName?: SamText
  ampps?: Array<Ampp>
  components?: Array<AmpComponent>
}
export namespace Amp {
  export type StatusEnum = 'AUTHORIZED' | 'SUSPENDED' | 'REVOKED'
  export const StatusEnum = {
    AUTHORIZED: 'AUTHORIZED' as StatusEnum,
    SUSPENDED: 'SUSPENDED' as StatusEnum,
    REVOKED: 'REVOKED' as StatusEnum,
  }
  export type MedicineTypeEnum = 'ALLOPATHIC' | 'HOMEOPATHIC'
  export const MedicineTypeEnum = {
    ALLOPATHIC: 'ALLOPATHIC' as MedicineTypeEnum,
    HOMEOPATHIC: 'HOMEOPATHIC' as MedicineTypeEnum,
  }
}
